import { AlertInline } from '@storeblocks/inline-alert';
import { type FC } from 'react';

import { useTexts } from '@/hooks/useTexts';

import { FundInfo } from './FundInfo';

interface Props {
  isin: string;
}

export const SellAllInfo: FC<Props> = ({ isin }) => {
  const texts = useTexts();

  return (
    <FundInfo>
      <AlertInline
        data-test={`sell-all-info-inline-${isin}`}
        variant="info"
        title={texts.orders.form.redemption.unitsWillBeUsed}
      />
    </FundInfo>
  );
};
